import api from '../core/api';

const findAll = async () => {
  const result = await api.get('/specials');
  const specials = result.data;
  return specials;
};

export default {findAll};
